import { gql } from '@moonpig/web-core-graphql'

const PRODUCT_FIELDS_FRAGMENT = gql`
  fragment ProductVariant on ProductVariant {
    key
    title
    subtitle
    inStock
    sku
    minimumQuantity
    price {
      centAmount
      currencyCode
      fractionDigits
    }
    fullPrice {
      centAmount
      currencyCode
      fractionDigits
    }
    discountedPercentage
    dimensions {
      description
    }
    capabilities {
      video
    }
  }

  fragment ProductDynamicImages on Product {
    appliedIntents {
      intentId
      value
      ordinal
    }
    dynamicImages {
      intentKey
      large {
        webp {
          title
          url
        }
      }
      medium {
        webp {
          title
          url
        }
      }
    }
  }

  fragment Product on Product {
    id
    title
    slug
    dependencies
    customisable
    isLandscape
    clickRankDocumentCount
    category {
      id
      slug
      name
      department
    }
    range {
      key
    }
    rating {
      count
      score
    }
    masterVariant {
      ...ProductVariant
      productImages {
        mainImage {
          medium {
            jpgUrl
          }
        }
        images {
          small {
            jpgUrl
          }
          medium {
            jpgUrl
          }
          large {
            jpgUrl
          }
        }
      }
    }
    variants {
      ...ProductVariant
    }
    hasAugmentedReality
    productPills {
      displayLabel
      displayVariant
    }
    primaryProductPill {
      displayLabel
      displayVariant
    }
    publishDate
    isSponsored
  }
`

export const MoreLikeThisGQL = gql`
  query MoreLikeThis(
    $productKey: String!
    $filters: CriteriaInput!
    $searchTerm: String
    $limit: Int
    $appliedIntents: [AppliedIntentInput!]
    $range: String
  ) {
    moreLikeThis(
      productKey: $productKey
      filters: $filters
      searchTerm: $searchTerm
      limit: $limit
      appliedIntents: $appliedIntents
      range: $range
    ) {
      ...Product
      ...ProductDynamicImages
    }
  }
  ${PRODUCT_FIELDS_FRAGMENT}
`
